import React from "react";
import Toast from "./Toast";
import "./Toast.css";

const ToastContext = React.createContext(null);

export function useToast() {
  return React.useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = React.useState([]);

  const showToast = React.useCallback(
    ({
      type = "success",
      title,
      message,
      duration = 9000,
      onClick,
      avatarUrl = "",
      avatarInitials = "",
      meta = "",
    }) => {
      const id = Date.now() + Math.random();

      setToasts((prev) => [
        ...prev,
        {
          id,
          type,
          title,
          message,
          onClick,
          avatarUrl,
          avatarInitials,
          meta,
          duration,
        },
      ]);
    },
    [],
  );

  const removeToast = React.useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const contextValue = React.useMemo(
    () => ({
      showToast,
    }),
    [showToast],
  );

  return (
    <ToastContext.Provider value={contextValue}>
      {children}

      <div className="toast-container">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            {...toast}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
